<template>
  <div class="sticky top-20">
    <span v-show="this.showHeader" 
    class="font-medium hidden lg:block mb-1"
    :class="{'text-sm': campaignViewType === 'Refreshed'}"
    >Share</span>

    <div class="flex flex-inline lg:flex-col items-center content-center space-x-2 lg:space-x-0 lg:space-y-2 justify-center">
      
      <s-facebook
        :window-features="windowFeatures"
        :share-options="facebookShareOptions"
        :use-native-behavior="false"
        class="text-white bg-facebook-100 hover:bg-facebook-200 h-10 w-10 rounded-full flex items-center justify-center"
      >
        <i class="fab fa-facebook-f"></i>
      </s-facebook>
      
      <s-twitter
        :window-features="windowFeatures"
        :share-options="twitterShareOptions"
        :use-native-behavior="false"
        class="text-white bg-blue hover:bg-blue-600 h-10 w-10 rounded-full flex items-center justify-center"
      >
        <i class="fab fa-twitter"></i>
      </s-twitter>
      
      <a :href="this.mailToText" target="_top"  class="text-white bg-pink hover:bg-pink-600 h-10 w-10 rounded-full flex items-center justify-center">
        <i class="fas fa-envelope"></i>
      </a>
    </div>

  </div>

</template>

<script>
  import Modal from '../ui/Modal'
  import { SFacebook, STwitter, SEmail } from 'vue-socials'

  export default {
    name: 'ShareLink',

    props: {
      campaignId: {
        required: true,
      },
      campaign: {
        required: false,
      },
      showHeader: {
        type: Boolean,
        default: false,
      },
      useClass: {
        default: 'share-buttons d-inline-flex pt-2',
      },
      useStyle: {
        type: String,
      },
    },

    components: { Modal, SFacebook, STwitter, SEmail },

    data() {
      return {
        shareModalIsOpen: false,
        windowFeatures: {},
      }
    },

    computed: {
      facebookShareOptions() {
        return {
          url: this.campaignUrl,
          quote: '',
          hashtag: '#WeWontIgnoreStageIV',
        }
      },
      
      twitterShareOptions() {
        return {
          url: this.campaignUrl,
          text: this.twitterText,
          hashtags: ['DigPink', 'MBC'],
        }
      },
      
      campaignUrl() {
        return `https://giving.side-out.org/campaigns/${this.campaignId}`
        return `${process.env.MIX_APP_URL}/campaigns/${this.campaignId}`
      },

      getClass() {
        return this.useClass
      },

      campaignName() {
        if (!(this.campaign)) {
          return ''
        }
        return this.campaign.name
      },

      userFirstName() {
        if (!(this.campaign) || !(this.campaign.user)) {
          return ''
        }
        return this.campaign.user.first_name
      },

      mailSubject() {
        return 'Help support our Dig Pink campaign!'
      },
      mailToText() {
        return 'mailto:?subject=' + this.mailSubject + '&body=Support ' + this.userFirstName + ' and our efforts to raise funds for game changing stage IV breast cancer research. ' + this.campaignUrl
      },
      facebookText() {
        return 'Support ' + this.campaignName + ' and our efforts to raise funds for game changing stage IV breast cancer research. ' + this.campaignUrl + ' #WeWontIgnoreStageIV'
      },
      twitterText() {
        return 'Help support our #DigPink campaign & game-changing #MBC research!'
      },
      campaignViewType() {
        return this.$store.state.campaignWidget.campaignViewType;
      },
    },

  }
</script>

<style scoped>

</style>
